import type { GroupMonthlyPayments, MonthlyPaymentStatus } from '@/api/monthlyPaymentsApi'

/** Parse rubles without accepting rounding of a third decimal place. */
export function parseMonthlyPrice(input: string): number | null {
  const value = input.trim().replace(',', '.')
  if (!/^\d+(\.\d{1,2})?$/.test(value)) return null
  const kopecks = Math.round(Number(value) * 100)
  return Number.isSafeInteger(kopecks) ? kopecks : null
}
export function paymentRows(data?: GroupMonthlyPayments): MonthlyPaymentStatus[] {
  return [...(data?.athletes ?? []), ...(data?.paused ?? []).map(a => ({ ...a, is_paused: true }))]
}
export function filterPaymentRows(rows: MonthlyPaymentStatus[], search: string, status: string): MonthlyPaymentStatus[] {
  return rows.filter(a => a.athlete_name.toLocaleLowerCase().includes(search.toLocaleLowerCase()) && (status === 'all' || (status === 'paid' && a.is_paid) || (status === 'unpaid' && !a.is_paid && !a.is_paused) || (status === 'paused' && a.is_paused)))
}
